const ARTICLES_SUMMARY_SESSION_STORAGE_KEY = 'prk-articles-summary';

const BOOKMARK_LOCAL_STORAGE_KEY = 'prk-blog-bookmarks';

export class BookmarksStorage {
    /**
     * @param {string}articleId
     * @return boolean
     */
    addArticle(articleId) {
        const articleIds = this.getBookmarkedArticleIds();
        if (!articleId || articleIds.includes(articleId)) {
            return false;
        }

        articleIds.unshift(articleId);

        this._saveBookmarkedArticleIds(articleIds);

        return true;
    }

    /**
     * @param {string}articleId
     */
    containsArticle(articleId) {
        return this.getBookmarkedArticleIds().includes(articleId);
    }

    /**
     * @param {string}articleId
     * @return boolean
     */
    removeArticle(articleId) {
        const articleIds = this.getBookmarkedArticleIds();
        if (!articleIds.includes(articleId)) {
            return false;
        }

        this._saveBookmarkedArticleIds(
            this.getBookmarkedArticleIds()
                .filter((id) => id !== articleId)
        );

        return true;
    }

    /**
     * @return {string[]}
     */
    getBookmarkedArticleIds() {
        try {
            if (typeof localStorage !== 'undefined') {
                const articleIds = JSON.parse(localStorage.getItem(BOOKMARK_LOCAL_STORAGE_KEY));
                if (Array.isArray(articleIds)) {
                    return articleIds;
                }
            }
        } catch (e) {
        }

        return [];
    }

    isEmpty() {
        return this.getBookmarkedArticleIds().length === 0;
    }

    /**
     * @param {string[]} articleIds
     * @return void
     */
    _saveBookmarkedArticleIds(articleIds) {
        try {
            if (typeof localStorage !== 'undefined') {
                localStorage.setItem(BOOKMARK_LOCAL_STORAGE_KEY, JSON.stringify(articleIds));
            }
        } catch (e) {
        }
    }
}

/**
 * @param {string[]} articleIds
 */
export const getBookmarkedArticlesSummary = async (articleIds) => {
    if (articleIds.length === 0) {
        return [];
    }

    try {
        if (typeof sessionStorage !== 'undefined') {
            let articles = JSON.parse(sessionStorage.getItem(ARTICLES_SUMMARY_SESSION_STORAGE_KEY)) ?? [];

            articles = articles.filter((item) => articleIds.includes(item.id));

            if (articles.map((item) => item.id).sort().join() === [...articleIds].sort().join()) {
                return articles.sort((a, b) => articleIds.indexOf(a.id) < articleIds.indexOf(b.id) ? -1 : 1);
            }
        }
    } catch (e) {
    }

    return fetch('/api/prk/blog/articles/', {
        method: 'POST',
        body: JSON.stringify({ articleIds }),
    })
        .then((response) => response.json())
        .then((data) => {
            if (Object.prototype.hasOwnProperty.call(data, 'articles')) {
                return data.articles;
            }

            return [];
        })
        .then((articles) => {
            articles = articles
                .sort((a, b) => articleIds.indexOf(a) < articleIds.indexOf(b) ? -1 : 1)
                .map((item) => ({
                    ...item,
                    id: String(item.id),
                }));

            sessionStorage.setItem(ARTICLES_SUMMARY_SESSION_STORAGE_KEY, JSON.stringify(articles));

            return articles;
        })
        .catch(() => []);
}